const styles = () => ({
  addNewButton: { marginTop: 10 },
  listHeaderContainer: { display: 'flex', justifyContent: 'space-between' },
  list: { maxWidth: 600 },
  saveIcon: { color: 'blue' },
  deleteIcon: { color: 'red' }
});

export default styles;
